import PillarCTA from './PillarCTA'

export default PillarCTA